/* eslint-disable import/prefer-default-export */
export const CLOUD_FUNCTIONS_URL = process.env.VUE_APP_CLOUD_FUNCTIONS_URL;
export const API_URL = `${CLOUD_FUNCTIONS_URL}/releases`;
